export default __webpack_public_path__ + "static/media/people.1e9c04d6.svg";